import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { handleRetrieveAllBookings } from "../../../../redux/specialist-slices/webinar.slice";
import TablePagination from "../../../../components/common/TablePagination";
import TableSkell from "../../../../components/common/TableSkell";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function Bookings() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const { refresh, loadings } = useSelector((state) => state.otherSlice);

  // Handle retrieve all FAQs
  const handleRetrieveAll = (filters) => {
    dispatch(
      handleRetrieveAllBookings({
        id,
        currentPage: filters?.currentPage || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    handleRetrieveAll();

    // eslint-disable-next-line
  }, [refresh]);

  return (
    <Box className="content-listing">
      <TableContainer className="adminTable1">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Name", "Email"]?.map((cell, i) => (
                <TableCell key={i} align="left">
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loadings?.retrieveAll ? (
              <TableSkell colLength={2} />
            ) : (
              data?.records?.map((element, i) => (
                <TableRow
                  key={i}
                  tabIndex={-1}
                  role="checkbox"
                  sx={{
                    td: {
                      borderBottomWidth:
                        i === data?.records?.length - 1 ? "0" : "1px",
                    },
                  }}
                >
                  <TableCell sx={{ textTransform: "capitalize" }}>
                    {element?.member?.fullName}
                  </TableCell>
                  <TableCell>{element?.member?.email}</TableCell>
                </TableRow>
              ))
            )}

            {!data?.records?.length && !loadings?.retrieveAll && (
              <TableRow sx={{ td: { borderBottom: "none" } }}>
                <TableCell colSpan={2}>
                  <Typography variant="noRecords">No results found!</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        pagination={data?.pagination}
        length={data?.records?.length}
        loading={loadings?.retrieveAll}
      />
    </Box>
  );
}

export default Bookings;
